import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Copyright = ({ backgroundClass = "bg-white" }) => {
  const { t } = useTranslation();

  return (
    <footer
      className={`${backgroundClass} px-[30px]  h-[50px] w-full max-w-[480px] flex justify-between items-center footer  mx-auto`}
    >
      <div className="flex items-center justify-between flex-1 text-xs text-[#E9E6E4] font-medium">
        {t("copyRight.copyRight2025Rally")}
      </div>
      <div className=" text-xs text-[#A0A0A0] font-medium">
        {t("support.anyIssues")}{" "}
        {/* <span className="underline" >{t("support.contactUs")}</span> */}
        <Link to="/profile/support/contactUS" className="underline">
          {t("support.contactUs")}
        </Link>
      </div>
    </footer>
  );
};

export default Copyright;
